// ノードのレベルを表す縦線（ガイド）を実要素として行に追加する。
// グラデーション背景や擬似要素で描くと、環境によっては折り返しのある行で
// 線の描画が抜けることがあるため、レベルごとの span の border で描く。
export function appendLevelGuides(row, depth, isLastChildPath = []) {
  if (!row || depth <= 0) {
    return;
  }
  const guides = document.createElement('div');
  guides.className = 'node-guides';
  for (let i = 0; i < depth; i++) {
    const guide = document.createElement('span');
    guide.className = 'node-guide';
    guides.append(guide);
  }
  row.append(guides);
}
